import "./App.scss";

import Header from "./components/Header/Header";

import Iphone from "./assets/mockup1.png";
import img1 from "./assets/img-1.png";
import img2 from "./assets/img-2.png";
import { useRef, useEffect, useState } from "react";
import ReactCompareImage from "react-compare-image";
import { ReactComponent as Apple } from "./assets/apple.svg";
import Footer from "./components/Footer/Footer";
import Modal from "./components/Modal/Modal";
import DownloadInfos from "./components/DownloadInfos/DownloadInfos";
import Contact from "./components/Contact/Contact";

const camImages = Array.from({ length: 10 }, (_, i) =>
  require(`./assets/photos/cam-${i + 1}.webp`)
);

function App() {
  const iphoneRef = useRef(null);
  const [showDownload, setShowDownload] = useState(false);
  const [showContact, setShowContact] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target);
        }
      });
    });

    document.querySelectorAll(".fadeInUp").forEach((el) => {
      observer.observe(el);
    });
  }, []);

  const allCamImages = [...camImages, ...camImages];

  return (
    <div className="App">
      <Header />
      <section className="wrapper hero">
        <div className="container">
          <h1 className="title-font">
            Capture&nbsp;<span className="i">memories</span>{" "}
            <span className="gradient">, not pixels.</span>
          </h1>
          <p>No more tweaking settings. Just shoot.</p>
        </div>
      </section>

      <section className="slider wrapper">
        <img className="iphone" src={Iphone} alt="" ref={iphoneRef} style={{ opacity: 0 }} />
        <div className="marquee">
          <div className="overlay"></div>
          <div className="marquee__inner">
            {allCamImages.map((src, index) => (
              <div className="marquee__item" key={index}>
                <img src={src} alt={`Cam ${index}`} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="spacer"></div>

      <section className="benefits wrapper">
        <div className="container">
          <div className="grid">
            <h2 className="title-font fadeInUp">
              Say goodbye to <br />
              <span className="i">overprocessed</span> photos.
            </h2>
            <p className="fadeInUp">
              Most smartphone cameras today overprocess every shot excessive sharpening, fake HDR
              glows, blown-out highlights, crushed shadows. They chase clarity, but kill mood. What
              you get isn’t a photo, it’s a prediction of what a photo should look like. Flowcam
              strips all of that away. No filters. Very few enhancement. Just what your lens saw.
            </p>
          </div>
          <div className="compare fadeInUp">
            <ReactCompareImage leftImage={img1} rightImage={img2} sliderPositionPercentage={0.5} />
          </div>
        </div>
      </section>

      <section className="wrapper CTA">
        <div className="container">
          <h2 className="title-font fadeInUp">
            Just shoot what's on <span className="i">your mind</span>.
          </h2>
          <p className="fadeInUp">
            Flowcam is still in beta — expect a few bumps along the way. Your feedback will help
            make it even better. Thanks for your patience!
          </p>
          <button className="btn fadeInUp" onClick={() => setShowDownload(true)}>
            <Apple />
            Join the first testers
          </button>
        </div>
      </section>
      <Modal
        isOpen={showDownload}
        onClose={() => setShowDownload(false)}
        size="large"
        title="How to install Flowcam"
      >
        <DownloadInfos
          onRequestContact={() => {
            setShowDownload(false);
            setShowContact(true);
          }}
        />
      </Modal>
      <Modal
        isOpen={showContact}
        size="large"
        onClose={() => setShowContact(false)}
        title="Contact"
      >
        <Contact />
      </Modal>
      <Footer />
    </div>
  );
}

export default App;
